'use client';
import { useAccount } from 'wagmi';

export default function useWalletConnection() {
  const connection = useAccount();

  return connection
}
